module.exports = __webpack_public_path__ + "img/XL_PERSO_FILTRE.fcc79fa6.svg";